import { Helmet } from "react-helmet-async"

import BreadCrumbs from "../components/BreadCrumbs"
import travelScene from "../images/coconut-joy-1.jpg"
import ComingSoon from "../components/ComingSoon"
import { signUpClickHandler } from "../utilities/helpers"
import { useAuth } from "../hooks/useAuth"

export default function Contact() {
    const isLoggedIn = useAuth()

    const crumbs = [
        {
            path: "/",
            name: "Chaperon",
        },
        {
            path: "/contact",
            name: "Contact Us",
        },
    ]
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`Chaperon - Contact us - We've got you covered`}</title>
            </Helmet>
            <BreadCrumbs crumbs={crumbs} />
            <ComingSoon />
            <div className="App-content text-center pt-2 align-items-center ">
                <div className="row">
                    <div className="col">
                        <h2 className="featurette-heading fw-normal lh-1 pt-2">
                            We're here for{" "}
                            <span className="text-body-secondary">you</span>.
                        </h2>
                    </div>
                    <div className="col">
                        <h2 className=" pt-2">&nbsp;</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="row row-cols-auto featurette container-fluid">
                        <div className="col-md-7">
                            <p className="text-start lead">
                                It is our honor to be able to serve you and
                                provide you with the best possible service. We
                                are committed to ensuring that your experience
                                with us is exceptional, and we are always here
                                to assist you with any questions or concerns you
                                may have.
                                <br></br>
                                <br></br>
                                Please let us know how we can help you, or if
                                you just want to say hello and share your
                                feedback on our service. We value your feedback
                                and so cherish the opportunity to hear your
                                suggestions, which we always take into
                                consideration and usually find to be brilliant
                                and golden.
                                <br></br>
                                <br></br>
                                Feel free to reach out using our contact form.
                                We will respond to your inquiry as soon as
                                possible, typically within 24 hours.
                                <br></br>
                                <br></br>
                                <b>
                                    We are also actively looking for alpha
                                    testers and partners who are interested in
                                    joining our waiting list to get early access
                                    to our platform and new features.
                                </b>{" "}
                                If you are interested, please let us know in the
                                contact form.<br></br>
                                Thank you.
                                <br></br>
                            </p>
                            <button
                                type="button"
                                className="btn btn-secondary m-1 btn-lg"
                                title="Learn more about what Chaperon offers"
                                onClick={signUpClickHandler}
                            >
                                Benefits & Features
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary m-1 btn-lg disabled"
                                title="Mobile and Desktop apps coming soon"
                            >
                                Download apps
                            </button>
                        </div>
                        <div className="col-md-4">
                            <section id="contact" className="p-3 bg-light mb-5">
                                <div className="container">
                                    <h2 className="text-center mb-5">
                                        Get in Touch
                                    </h2>
                                    <div className="row">
                                        <div className="col-lg-12 mx-auto">
                                            <form
                                                id="contact-form"
                                                className="mb-5"
                                                action="https://api.web3forms.com/submit"
                                                method="POST"
                                            >
                                                <input
                                                    type="hidden"
                                                    name="access_key"
                                                    value="73efab78-ed92-49fc-abdb-672d4e8e66cb"
                                                />

                                                <input
                                                    type="hidden"
                                                    name="subject"
                                                    value="New Message from Chaperon form"
                                                />

                                                <input
                                                    type="hidden"
                                                    name="from_name"
                                                    value="Chaperon Contact Form"
                                                />

                                                <input
                                                    type="hidden"
                                                    name="redirect"
                                                    value="https://chaperonapp.com"
                                                />

                                                <input
                                                    type="checkbox"
                                                    name="botcheck"
                                                    className="hidden"
                                                    style={{ display: "none" }}
                                                />

                                                <div
                                                    className="h-captcha d-flex justify-content-center mb-3"
                                                    data-captcha="true"
                                                ></div>

                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Name"
                                                    name="First Name"
                                                    required
                                                />
                                                <input
                                                    type="email"
                                                    className="form-control mb-3"
                                                    placeholder="Email"
                                                    name="email"
                                                    required
                                                />
                                                <textarea
                                                    className="form-control mb-3"
                                                    placeholder="Message"
                                                    name="message"
                                                    required
                                                ></textarea>
                                                <div className="form-floating my-3">
                                                    <select
                                                        className="form-select"
                                                        aria-label="How did you hear about us?"
                                                        id="referenceSelect"
                                                    >
                                                        <option value="friend">
                                                            Friend/Family
                                                        </option>
                                                        <option value="colleague">
                                                            Co-worker/Colleague
                                                        </option>
                                                        <option value="online">
                                                            Online Advertisment
                                                        </option>
                                                        <option value="flyer">
                                                            Printed Flyer
                                                        </option>
                                                        <option value="search">
                                                            Online search
                                                        </option>
                                                        <option value="other">
                                                            Other
                                                        </option>
                                                    </select>
                                                    <label htmlFor="referenceSelect">
                                                        How did you hear about
                                                        us?
                                                    </label>
                                                </div>
                                                <input
                                                    className="form-check-input me-2 bg-danger"
                                                    type="checkbox"
                                                    value=""
                                                    name="waiting"
                                                    id="waitingCheckbox"
                                                    defaultChecked
                                                ></input>
                                                <label
                                                    className="form-check-label mb-3"
                                                    htmlFor="waitingCheckbox"
                                                >
                                                    Join waiting list for early
                                                    access
                                                </label>

                                                <button
                                                    type="submit"
                                                    className="btn btn-danger w-100 mb-5"
                                                >
                                                    Send Message
                                                </button>
                                            </form>

                                            <script
                                                src="https://web3forms.com/client/script.js"
                                                async
                                                defer
                                            ></script>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col">
                        <h2 className="pt-2">&nbsp;</h2>
                    </div>
                    <div className="col">
                        <h2 className="featurette-heading fw-normal lh-1 pt-2 text-start">
                            Frequently Asked{" "}
                            <span className="text-body-secondary">
                                Questions
                            </span>
                            .
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="row row-cols-auto featurette container-fluid">
                        <div className="col-md-5">
                            <img
                                src={travelScene}
                                alt="Travel Scene"
                                width="100%"
                                style={{ borderRadius: "10px" }}
                            />
                        </div>
                        <div className="col-md-7">
                            <div className="accordion py-2" id="pricingFAQ">
                                <div className="accordion-item">
                                    <h3 className="accordion-header">
                                        <button
                                            className="accordion-button"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                        >
                                            Can I use Chaperon for free?
                                        </button>
                                    </h3>
                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse show"
                                        data-bs-parent="#pricingFAQ"
                                    >
                                        <div className="accordion-body">
                                            Yes! We are always doing our best to
                                            ensure that everyone can access
                                            Chaperon for free to get safety
                                            information for just about anywhere
                                            in the world.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h3 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo"
                                        >
                                            Can I create and account and sign up
                                            now?
                                        </button>
                                    </h3>
                                    <div
                                        id="collapseTwo"
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#pricingFAQ"
                                    >
                                        <div className="accordion-body">
                                            Not yet. We're almost ready to
                                            launch our advanced features that
                                            will bring even more value to your
                                            travel experience and everyday life
                                            on a personal and customized level.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h3 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                        >
                                            Will Chaperon only be available for
                                            some retricted part of the world?
                                        </button>
                                    </h3>
                                    <div
                                        id="collapseThree"
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#pricingFAQ"
                                    >
                                        <div className="accordion-body">
                                            No. Chaperon is designed to provide
                                            safety information for just about
                                            anywhere in the world. We are
                                            constantly expanding our coverage to
                                            ensure that you can access safety
                                            data for a wide range of locations,
                                            including remote and less-traveled
                                            areas.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h3 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour"
                                        >
                                            Does Chaperon sell its users'
                                            personal data?
                                        </button>
                                    </h3>
                                    <div
                                        id="collapseFour"
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#pricingFAQ"
                                    >
                                        <div className="accordion-body">
                                            No, never! Chaperon is committed to
                                            protecting your privacy and does not
                                            sell your personal data to third
                                            parties. We only use your data to
                                            provide you with the best possible
                                            service and to improve our platform.
                                            Your personal information is always
                                            kept secure and confidential.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5">
                                <button
                                    type="button"
                                    className="btn btn-danger m-1 btn-lg"
                                    onClick={signUpClickHandler}
                                >
                                    Explore your world
                                </button>
                                {!isLoggedIn && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary m-1 btn-lg"
                                        onClick={signUpClickHandler}
                                    >
                                        Sign up
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
